import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["badge"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
import "core-js/modules/es.object.keys.js";
import { useQueryClient } from 'react-query';
import { useUpdatePlaylistBadge } from 'actions/badges';
import { useUpdatePlaylists } from 'actions/playlists';
import playlistKeys from 'actions/playlists/queryKeys';
import { formatPlaylistEditorPayloadForApi } from './formatPlaylistEditorPayloadForApi';
import { useState } from 'react';
export function useSubmitPlaylistEditor(_ref) {
  var playlistId = _ref.playlistId,
    parentPlaylistId = _ref.parentPlaylistId,
    ownerTeamId = _ref.ownerTeamId,
    badge = _ref.badge,
    onSuccess = _ref.onSuccess;
  var queryClient = useQueryClient();
  var _useUpdatePlaylists = useUpdatePlaylists({
      playlistIds: [playlistId],
      ownerTeamId: ownerTeamId
    }),
    updatePlaylists = _useUpdatePlaylists.updatePlaylists;
  var _useUpdatePlaylistBad = useUpdatePlaylistBadge(playlistId, badge),
    updatePlaylistBadge = _useUpdatePlaylistBad.updatePlaylistBadge;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isSubmissionLoading = _useState2[0],
    setIsSubmissionLoading = _useState2[1];
  function submitPlaylistEditor(_x) {
    return _submitPlaylistEditor.apply(this, arguments);
  }
  function _submitPlaylistEditor() {
    _submitPlaylistEditor = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(payload) {
      var newBadgeData, playlistChanges;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            newBadgeData = payload.badge, playlistChanges = _objectWithoutProperties(payload, _excluded);
            setIsSubmissionLoading(true);

            // Only update playlist if playlist data was changed
            if (!(Object.keys(playlistChanges).length > 0)) {
              _context.next = 5;
              break;
            }
            _context.next = 5;
            return updatePlaylists(formatPlaylistEditorPayloadForApi(playlistChanges));
          case 5:
            if (!newBadgeData) {
              _context.next = 8;
              break;
            }
            _context.next = 8;
            return updatePlaylistBadge({
              contentId: playlistId,
              badgeId: badge === null || badge === void 0 ? void 0 : badge.id,
              imageId: newBadgeData.imageId
            });
          case 8:
            onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
            _context.next = 11;
            return queryClient.invalidateQueries(playlistKeys.singlePlaylist(playlistId));
          case 11:
            if (!parentPlaylistId) {
              _context.next = 14;
              break;
            }
            _context.next = 14;
            return queryClient.invalidateQueries(playlistKeys.singlePlaylist(parentPlaylistId));
          case 14:
            setIsSubmissionLoading(false);
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return _submitPlaylistEditor.apply(this, arguments);
  }
  return {
    submitPlaylistEditor: submitPlaylistEditor,
    isSubmissionLoading: isSubmissionLoading
  };
}